
export const mobileDevice = 767;
export const defaultDevice = 768;
export const largeDevice = 1200;
